import translations from './const/uz.json';

export default {
  translation: {
    ...translations
  }
}